import { ThemeFactory } from "../../ThemeFactory";
export var DEFAULT_THEME = ThemeFactory.create({});